import { combineReducers } from '@reduxjs/toolkit'
import RoleReducer from './reducer'
const reducer = combineReducers({
  RoleReducer,
})

export default reducer
